.App {
  background-color: #212121;
  width: 100%;
  height: 100%;
  position: relative;
}
